<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid">
  <app-assignments-table></app-assignments-table>
  <app-bookings-assignments-table></app-bookings-assignments-table>
  <div class="masonry">
    <div class="item">
      <app-notifications-list></app-notifications-list>
    </div>
    <div class="item">
      <app-reminders-list></app-reminders-list>
    </div>
    <div class="item">
      <app-upcoming-events-list></app-upcoming-events-list>
    </div>
    <div class="item">
      <app-last-bookings-list></app-last-bookings-list>
    </div>
  </div>
</div>
